import { RootState } from '../../store';

export const selectOrder = (state: RootState) => state.orders.single.data;
export const selectOrderLoading = (state: RootState) => state.orders.single.loading;
export const selectOrderError = (state: RootState) => state.orders.single.error;

export const selectCreateOrder = (state: RootState) => state.orders.create.data;
export const selectCreateOrderLoading = (state: RootState) => state.orders.create.loading;
export const selectCreateOrderError = (state: RootState) => state.orders.create.error;

export const selectOrdersByOrganization = (state: RootState) =>
  state.orders.byOrganization.data;
export const selectOrdersByOrganizationLoading = (state: RootState) =>
  state.orders.byOrganization.loading;
export const selectOrdersByOrganizationError = (state: RootState) =>
  state.orders.byOrganization.error;
